import Page from "components/common/layout/Page";
import { FeatureRequest, FeatureRequestListItem } from "interfaces/feature-request";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getIdToken } from "services/auth/auth";
import LoadingIndicator from "../../components/common/ui/LoadingIndicator/LoadingIndicator";
import ListPage from "./list/ListPage";
import useQuery from "hooks/common/useQuery/useQuery";
import DetailsPage from "./details/DetailsPage";
import useFetch from "hooks/common/useFetch/useFetch";
import LoadingWrapper from "./shared/LoadingWrapper";
import { useHierarchicalNavigation } from "hooks/common/useHierarchicalNavigation/useHierarchicalNavigation";

const FeatureRequestsPage: React.FC = () => {
    const { featureRequestId } = useQuery(["featureRequestId"]);
    const history = useHistory();
    const { back } = useHierarchicalNavigation("featureRequestId", "previousFeatureRequestIds");
    const token = useSelector(getIdToken);

    const {
        data: featureRequests,
        loading: featureRequestsLoading,
        error: featureRequestsError,
        fetchData: fetchFeatureRequests,
    } = useFetch<FeatureRequestListItem[]>();

    const {
        data: featureRequest,
        loading: featureRequestLoading,
        error: featureRequestError,
        fetchData: fetchFeatureRequest,
        setData: setFeatureRequest,
    } = useFetch<FeatureRequest>();

    const loading = featureRequestsLoading || featureRequestLoading;
    const error = featureRequestsError || featureRequestError;

    useEffect(() => {
        if (!token) {
            history.replace("/");
        }
    }, [token, history]);

    useEffect(() => {
        fetchFeatureRequests("/api/feature-requests");
    }, [fetchFeatureRequests]);

    useEffect(() => {
        if (featureRequestId) {
            fetchFeatureRequest(`/api/feature-requests/${featureRequestId}`);
        } else {
            setFeatureRequest(null);
        }
    }, [featureRequestId, fetchFeatureRequest, setFeatureRequest]);

    return (
        <Page>
            {error && <p>{error}</p>}
            {loading && (
                <LoadingWrapper>
                    <LoadingIndicator isLoading={loading} />
                </LoadingWrapper>
            )}
            {!!featureRequest && !loading && !error && (
                <DetailsPage onBack={back} featureRequest={featureRequest} />
            )}
            <ListPage
                featureRequests={featureRequests || []}
                visible={!featureRequestId && !loading && !error}
            />
        </Page>
    );
};

export default FeatureRequestsPage;
